import { HopperAnimatic, HopperAnimaticProps } from '@crossnokaye/ux-animatics';

import { ANIMATIC_PRIMARY_LABEL_EXACT } from '@/features/equipment-browser/animatics/animatics.constants';
import { getLabel } from '@/features/equipment-browser/animatics/animatics.helpers';
import { convertPercentToDecimal, getRefValue } from '@/features/equipment-browser/utils';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticHopper = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const hopperConfig = config.specificAnimaticConfig?.hopper;
  const levelRef = hopperConfig?.level;
  const level = levelRef ? convertPercentToDecimal(getRefValue(levelRef)) : undefined;
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL_EXACT);

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <HopperAnimatic
        primaryLabel={primaryLabel?.text}
        state={state}
        value={level}
        variant={hopperConfig?.variant as HopperAnimaticProps['variant'] | undefined}
      />
    </ScaledAnimatic>
  );
};
